import * as React from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react'
import { cartStore } from '../../cart'
import { modalStore } from '../../shared'
import { departments } from '../collections.data'
import { Departments } from '../collections.enums'
import { IDepartment } from '../collections.interfaces'
import { collectionsStore } from '../collections.store'
import { TabsCartModal } from './cart-modal'
import { TabsDepartmentModal } from './department-modal'
import './tabs.scss'

@observer
export class CollectionsTabs extends React.Component {
  baseClass: string = 'collections-tabs'

  componentDidMount(): void {
    if (this.queuedDepartmentHasRequiredIntro) {
      modalStore.set(this.departmentModal)
      modalStore.toggle()
    }
  }

  onDepartmentClick(department: IDepartment): void {
    if (cartStore.cartHasItems) {
      modalStore.set(this.cartModal)
      modalStore.toggle()
    } else {
      collectionsStore.activeDepartment = department
      if (this.queuedDepartmentHasRequiredIntro) {
        modalStore.set(this.departmentModal)
        modalStore.toggle()
      }
    }
  }

  get activeDepartmentId(): Departments {
    return collectionsStore.activeDepartment.id
  }

  get queuedDepartmentHasRequiredIntro(): boolean {
    return false
  }

  get cartModal(): JSX.Element {
    const cartModalProceed = (): void => {
      cartStore.clearCart()
      collectionsStore.activeDepartment = null

      // If the newly set active department has a required inro, swap the modal content
      if (this.queuedDepartmentHasRequiredIntro) {
        modalStore.set(this.departmentModal)
      } else {
        modalStore.toggle()
      }
    }

    return <TabsCartModal proceed={cartModalProceed} />
  }

  get departmentModal(): JSX.Element {
    return <TabsDepartmentModal proceed={modalStore.toggle} />
  }

  render(): React.ReactNode {
    return (
      <div className="container">
        <div className={`${this.baseClass} flex items--start justify--start`}>
          {departments.map((department) => {
            const props: object = {
              className: classnames(
                `${this.baseClass}__tab`,
                { [`${this.baseClass}__tab--active`]: department.id === this.activeDepartmentId }
              ),
              'data-department': department.id,
              key: department.name,
              onClick: (): void => this.onDepartmentClick(department)
            }
            return <button {...props}>{department.name}</button>
          })}
        </div>
      </div>
    )
  }
}
